module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#user-square",
      toString: function () {
        return this.url;
      }
    }